import type { FC } from 'react'
import UserAvatar from '../profile/user-avatar.js'
import { graphHooks } from '@tunasong/graph-lib/react'
import styles from './avatar-list.module.css'

export interface AvatarListProps {
  userIds: string[]
  size?: 'small' | 'medium' | 'large' | 'tiny'
}

/**
 * Display a list of user avatars that have access to the entity.
 */
export const AvatarList: FC<AvatarListProps> = props => {
  const { userIds, size = 'small' } = props
  /** The people listed, nobody else: `useProfiles` adds the assistant unless asked not to (GH #2861) */
  const { profiles } = graphHooks.useProfiles({
    userIds,
    includeAssistant: false,
  })
  return (
    <div className={styles.container}>
      {profiles.map(profile => (
        <UserAvatar key={profile.userId} className={styles.avatar} size={size} userId={profile.userId} />
      ))}
    </div>
  )
}

export default AvatarList
